// Module
var code = "<react-component name=\"ReviewList\"></react-component>\n";
// Exports
module.exports = code;